import { Button } from "reactstrap";
import { ImportIcon } from "../../constants/icons";
import "./Button.css";

const DownloadButton = (props) => {
  const syncing = !!props.syncing;
  return (
    <span
      className={`bomButtonsWrap${syncing ? " is-disabled" : ""}`}
      onMouseEnter={syncing ? props.onSyncingHover : undefined}
    >
      <Button
        className="bomButtons linkBtn download"
        type="button"
        disabled={syncing}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (syncing || !props.onClick) {
            return;
          }
          props.onClick(event);
        }}
      >
        <ImportIcon className="icon" />
        <div className="text">Download</div>
      </Button>
    </span>
  );
};

export default DownloadButton;
